export const BoostInactive = {
  parts: ['Container', 'Icon'],
  baseStyle: {
    Container: {
      bg: 'brand.lightgreen2',
      p: '5',
      borderBottom: '1px solid',
      borderColor: 'brand.lightgrey',
      pl: '64px',
      pr: '64px',
    },
 
    Label: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle',
      outline: 'none',
      width: 'auto',
      borderRadius: '16px',
      fontSize: 'xs',
      fontWeight: '600',
      textTransform: 'uppercase',
      bg: 'brand.green',
      color: 'brand.white',
      height: '32px',
      paddingLeft: '16px;',
      paddingRight: '16px;',
      paddingTop: '8px;',
      paddingBottom: '8px;',
      mb: '5',
      letterSpacing: '1px',
    },
  },
};
